import { AppDispatch } from '../store/store';
import { appendMiddle, incrementRound, reducePlayerCardCount, setMiddle, setPlayerTurn, setSomethingHappend } from '../store/gameSlice';
import { ThrowCardResponse } from './types/GameMessage';
import { playFeedback } from '../services/feedback';

/**
 * Applies the visual/state effect of a single card throw (ZNK / APPEND / SLICE) to the
 * redux game store. Shared by the websocket-driven handler (useGameMessageHandler) and the
 * offline single-player controller, so both paths render throws identically.
 */
export const applyThrowEffect = async (dispatch: AppDispatch, message: ThrowCardResponse): Promise<void> => {
  dispatch(setPlayerTurn({ player: message.nextPlayer }));
  dispatch(reducePlayerCardCount({ player: message.thrownByPlayer }));

  const cardDto = { ...message.cardDto, rotate: Math.floor(Math.random() * 71) - 35 };

  switch (message.playerEffect) {
    case 'ZNK':
      dispatch(appendMiddle({ card: cardDto }));
      playFeedback('znk');
      dispatch(setSomethingHappend({ message: "IT'S A ZNK" }));
      await new Promise(resolve => setTimeout(resolve, 1000));
      dispatch(setSomethingHappend({ message: null }));
      dispatch(setMiddle({ middle: [] }));
      break;

    case 'APPEND':
      dispatch(appendMiddle({ card: cardDto }));
      if (message.roundState === 'ROUND_FINISHED') {
        dispatch(incrementRound());
      }
      break;

    case 'SLICE':
      dispatch(appendMiddle({ card: cardDto }));
      playFeedback('slice');
      dispatch(setSomethingHappend({ message: "IT'S A SLICE" }));
      await new Promise(resolve => setTimeout(resolve, 1000));
      dispatch(setSomethingHappend({ message: null }));
      dispatch(setMiddle({ middle: [] }));
      break;
  }
};
